import request from './http';

export function lists(data = {}) {
  const params = {
    mold_id: data.mold_id || null,
    search: data.search || null,
    page: data.page || 1,
    page_size: data.page_size || 8,
  };
  return request.post('html/User/getSupplierList', params);
}

export function addSupplier(data) {
  return request.post('html/User/addSupplier', data);
}

export function editSupplier(data) {
  return request.post('html/User/editSupplier', data);
}

export function delSupplier(data) {
  return request.post('html/User/delSupplier', data);
}
